import React from 'react';
import { useAuthContext } from '../../context/auth';
import { useUploadMedia } from './use-upload-media';
import { v4 as uuidv4 } from 'uuid';
import { getFileExtension } from '../../utils';

export const useImageUpload = () => {
  const { userInfo } = useAuthContext();
  const { uploadPosterDirect } = useUploadMedia();
  const clientId = userInfo?.['custom:clientId'];
  const [isUploading, setIsUploading] = React.useState(false);

  const uploadImage = async (file: File): Promise<string | null> => {
    if (!clientId) {
      console.error('No clientId available');
      return null;
    }
    setIsUploading(true);

    try {
      const ext = getFileExtension(file.name);
      const result = await uploadPosterDirect('image', ext, file, uuidv4(), clientId);
      return result?.publicUrl ?? null;
    } catch (e) {
      console.error(e);
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  return { uploadImage, isUploading };
};
